module.exports = __webpack_public_path__ + "img/none.4aa2a266.png";